<template>
    <div class="online-preview">
        <div class="online-preview-header">
            <h1> Online Preview </h1>
        </div>
        <div class="online-preview-content" v-loading="loading" element-loading-text="Loading...">
            <template v-if="!loading">
                <iframe v-if="status === 200 && src" :src="src" width="100%" height="100%" frameborder="0"></iframe>
                <el-result v-else-if="status === 404" icon="warning" title="404"
                    subTitle="Sorry, the file you requested does not exist.">
                </el-result>
                <el-result v-else-if="status === 500" icon="error" title="404"
                    subTitle="Internal Server Error, please contact the administrator.">
                </el-result>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OnlinePreview',
    data() {
        return {
            loading: true,
            status: -1,
            src: ''
        }
    },
    computed: {
        code() {
            return this.$route.params.code;
        },
    },
    methods: {
        onShare() {
            this.loading = true
            this.axios.get(`/resource/share/${this.code}`).then((resp) => {
                this.loading = false
                this.status = resp.code
                if (resp.code === 200) {
                    this.src = resp.data.url
                }
            }).catch(() => {
                this.loading = false
                this.status === 500
            })
        }
    },
    mounted() {
        this.onShare()
    }
}
</script>

<style scoped lang="scss">
.online-preview {
    height: 100%;
    display: flex;
    flex-direction: column;

    .online-preview-content {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    iframe {
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
    }

    .online-preview-header {
        background-color: $theme-color;
        color: #fff;
        line-height: 40px;
        text-align: center;
        padding: 5px 0;

        h1 {
            font-size: 16px;
        }
    }
}
</style>